export default __webpack_public_path__ + "static/media/im-placeholder-table.f52b62dc.svg";